export const media = [
    { 
        key: "tonto",
        name: "Tonto National Monument VR",
        link: "http://swvirtualmuseum.nau.edu/wp/Tonto_panos/Tonto-NM-pano-tour.html",
        video: null,
        picture: null,
    },
    { 
        key: "timelapse",
        name: "Timelapse",
        link: "https://vimeo.com/214206963",
        video: "there needs to be",
        picture: null,
    },
    { 
        key: "chemVR",
        name: "Chem VR Documentary",
        link: "https://vimeo.com/209591527",
        video: null,
        picture: null,
    },
    { 
        key: "bbVR",
        name: "Basketball Play",
        link: "https://vimeo.com/214381757",
        video: null,
        download: "dropbox something or other",
        picture: null,
    },
    // { 
    //     key: "fictionVR",
    //     name: "Fiction VR Film",
    //     link: "",
    //     video: "there needs to be",
    //     picture: null,
    // },
    { 
        key: "fictionFilm",
        name: "White Lies",
        link: "https://vimeo.com/115537215",
        video: null,
        picture: null,
    },
]


// WEBPACK FOOTER //
// ./src/data/mediaObj.js